/*
 * VPDB - Virtual Pinball Database
 * Copyright (C) 2019 freezy <freezy@vpdb.io>
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 * Modified for sigmashake-pinball by SigmaShake, 2026.
 */

import type { HitObject } from "../physics/hit-object";
import type { EventProxy } from "./event-proxy";
import type { IPlayable } from "./iplayable";

export interface IHittable extends IPlayable {
  isCollidable(): boolean;
  getHitShapes(): HitObject[];
  getEventProxy(): EventProxy;
}

export function isHittable(arg: unknown): arg is IHittable {
  return (arg as IHittable).getHitShapes !== undefined;
}
